// extracted by mini-css-extract-plugin
export default {"newbieTaskModal":"style-module--newbieTaskModal--p068T","content":"style-module--content--6Y+87","action":"style-module--action--Q1Uyt"};